import {
  AtsCandidatesDataCollectionDocument,
  CreateCandidateDocument,
  CreateCandidateMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateCandidate = () => {
  const [createCandidate, { loading }] = useMutation(CreateCandidateDocument, {
    extractorFn: (data) => data.atsMutations.createAtsCandidate,
  })

  return {
    loading,
    create(variables: CreateCandidateMutationVariables) {
      return createCandidate({
        variables,
        refetchQueries: [AtsCandidatesDataCollectionDocument],
      })
    },
  }
}
